import { SupplierShopTypes } from "@/utils/ShopUtils";
import { useGlobalStore } from "@/store/hooks";
import { Form } from "antd";
import React from "react";
import { observer } from "mobx-react-lite";
import "./index.less";
import { Select } from "../BaseSelect";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { getRetailerFieldOptions } from "./utils";

interface RetailerFieldProps {
    shopId: number;
}

const RetailerField: React.FC<RetailerFieldProps> = function (props) {
    const { shopId } = props;

    const globalStore = useGlobalStore();
    const { supplierPartnershipsStore } = useOrderManagementStore();

    const shop = globalStore.shopMapping.get(shopId);
    if (!SupplierShopTypes.includes(shop?.type)) return null;

    const partnerships = supplierPartnershipsStore.supplierPartnershipsMap.get(shopId) || [];

    const { suspendedPartnershipsOptions, activePartnershipsOptions } = getRetailerFieldOptions(partnerships);

    const loading = supplierPartnershipsStore.supplierPartnershipsLoadingMap.get(shopId);

    return (
        <Form.Item
            className="search-field-retailer"
            label={<span className="search-field-label">代理商</span>}
            name="retailerShopIds"
        >
            <Select
                allowClear
                size="small"
                mode="multiple"
                maxTagCount={0}
                loading={loading}
                showSearch={{
                    filterOption: (input, option) => {
                        const searchKey = option?.["data-search-key"];

                        if (typeof searchKey === "string") {
                            if (searchKey.toLowerCase().indexOf(input) >= 0) {
                                return true;
                            }
                        }

                        return false;
                    },
                }}
                options={[
                    ...(activePartnershipsOptions?.length ? [{ label: "合作中的代理商", options: [] }] : []),
                    ...activePartnershipsOptions.map((groupOption) => ({
                        label: groupOption.label,
                        key: "ec_active_" + groupOption.label,
                        options: groupOption.options.map((option) => ({
                            key: option.value,
                            value: option.value,
                            "data-search-key": option.label,
                            label: option.label,
                        })),
                    })),
                    ...(suspendedPartnershipsOptions?.length ? [{ label: "已取消合作的代理商", options: [] }] : []),
                    ...suspendedPartnershipsOptions.map((groupOption) => ({
                        label: groupOption.label,
                        key: "ec_suspended_" + groupOption.label,
                        options: groupOption.options.map((option) => ({
                            key: option.value,
                            value: option.value,
                            "data-search-key": option.label,
                            label: option.label,
                        })),
                    })),
                ]}
            />
        </Form.Item>
    );
};

export default observer(RetailerField);
